// D-0118 (Rafael 27/10): quem substitui, reenvia e exclui recibo e comprovante do adiantamento.
// Mesma regra da API (AdiantamentoDocumentoPolicy.php); aqui só avisa e desabilita o botão.
// Vale também com o adiantamento já creditado. O aviso vai só aos responsáveis do evento.

export const PERFIS_DOC_ADIANTAMENTO = ['financeiro', 'gerentefinanceiro', 'financeiro.adiantamento', 'financeiro.credito', 'admin', 'diretor'];

export const AVISO_SEM_PERMISSAO_DOC = 'Só o Financeiro (ou admin/diretor) substitui, reenvia ou exclui recibo e comprovante do adiantamento.';

export function podeGerenciarDocAdiantamento(perfil) {
    return PERFIS_DOC_ADIANTAMENTO.includes(String(perfil || '').trim().toLowerCase());
}

// A coluna vem como objeto Arquivo (relação carregada), id cru ou null.
function temArquivo(valor) {
    return !!(valor && (typeof valor === 'object' ? valor.id : valor));
}

export const temReciboAdiantamento = (p) => temArquivo(p && p.arquivoreciboadiantamento);
export const temComprovanteAdiantamento = (p) => temArquivo(p && p.arquivocomprovantepagamento);
